import React from "react";
import { withCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import SingleHistory from "./singleHistory";

const History = ({
  taskComments,
  task_id,
  tasklist_id,
  color,
  taskDate,
  history,
  getColumnNo,
  config,
  board,
}) => {
  const [translation] = useTranslation("translations");
  return history && history.length > 0 ? (
    <div className="px-3 py-2">
      <></>
      <div style={{ maxHeight: "100vh", overflow: "auto" }}>
        {history &&
          history.map((item, index) => {
            let heading = getColumnNo(item?.tasklist_id);
            return (
              <SingleHistory
                key={index}
                history={item}
                getColumnNo={getColumnNo}
                heading={heading}
                config={config}
                board={board}
              />
            );
          })}
      </div>
    </div>
  ) : (
    <div className="px-3 py-2 task-created">
      <div>
        <p>{translation("task-created")}</p>
      </div>
      <div>{taskDate}</div>
    </div>
  );
};

export default withCookies(History);
